import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

export const useQRCode = (targetText: string, width = 200) => {
  const [QRCodeImage, setQRCodeImage] = useState<string>();
  useEffect(() => {
    QRCode.toDataURL(
      targetText,
      { margin: 1, width: width },
      (err, qrImage) => {
        setQRCodeImage(qrImage);
      }
    );
  }, [targetText, width]);
  return QRCodeImage;
};
